"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tinymceReact = require("@tinymce/tinymce-react");

var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));

var _functions = require("./functions");

require("tinymce/models/dom/model");

require("tinymce/themes/silver");

require("tinymce/icons/default");

require("tinymce/skins/ui/oxide/skin.min.css");

require("tinymce/plugins/advlist");

require("tinymce/plugins/anchor");

require("tinymce/plugins/autolink");

require("tinymce/plugins/autoresize");

require("tinymce/plugins/autosave");

require("tinymce/plugins/charmap");

require("tinymce/plugins/code");

require("tinymce/plugins/codesample");

require("tinymce/plugins/directionality");

require("tinymce/plugins/emoticons");

require("tinymce/plugins/fullscreen");

require("tinymce/plugins/help");

require("tinymce/plugins/image");

require("tinymce/plugins/importcss");

require("tinymce/plugins/insertdatetime");

require("tinymce/plugins/link");

require("tinymce/plugins/lists");

require("tinymce/plugins/media");

require("tinymce/plugins/nonbreaking");

require("tinymce/plugins/pagebreak");

require("tinymce/plugins/preview");

require("tinymce/plugins/quickbars");

require("tinymce/plugins/save");

require("tinymce/plugins/searchreplace");

require("tinymce/plugins/table");

require("tinymce/plugins/template");

require("tinymce/plugins/visualblocks");

require("tinymce/plugins/visualchars");

require("tinymce/plugins/wordcount");

require("tinymce/plugins/emoticons/js/emojis");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var propTypes = {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func.isRequired,
  onUpload: _propTypes.default.func,
  documentBaseUrl: _propTypes.default.string
};
var defaultProps = {
  onUpload: _functions.localAsBase64,
  documentBaseUrl: undefined
};

var FoxEditorTinyMCE = /*#__PURE__*/function (_PureComponent) {
  _inherits(FoxEditorTinyMCE, _PureComponent);

  function FoxEditorTinyMCE(props) {
    var _this;

    _classCallCheck(this, FoxEditorTinyMCE);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FoxEditorTinyMCE).call(this, props));
    var plugins = "\n      preview\n      importcss\n      searchreplace\n      autolink\n      autosave\n      save\n      directionality\n      code\n      visualblocks\n      visualchars\n      fullscreen\n      image\n      link\n      media\n      template\n      codesample\n      table\n      pagebreak\n      nonbreaking\n      anchor\n      insertdatetime\n      advlist\n      lists\n      wordcount\n      charmap\n      quickbars\n      emoticons\n      ";
    var toolbar = "\n      fontselect fontsizeselect formatselect |\n      undo redo |\n      bold italic underline strikethrough forecolorpicker backcolorpicker forecolor backcolor permanentpen formatpainter |\n      insertfile image media template link anchor codesample |\n      ltr rtl |\n      alignleft aligncenter alignright alignjustify |\n      numlist bullist outdent indent blockquote |\n      removeformat |\n      fullscreen preview save print |\n      charmap emoticons |\n      pagebreak |\n      addcomment |\n      pastetext pasteword |\n      code";
    _this.initOptions = {
      plugins: plugins,
      toolbar: toolbar,
      importcss_append: true,
      height: 400,
      statusbar: true,
      menubar: true,
      image_advtab: true,
      file_picker_types: 'image',
      paste_data_images: true,
      relative_urls: false,
      remove_script_host: false,
      document_base_url: _this.props.documentBaseUrl,
      images_upload_handler: _this.props.onUpload,
      image_caption: true,
      template_cdate_format: '[CDATE: %m/%d/%Y : %H:%M:%S]',
      template_mdate_format: '[MDATE: %m/%d/%Y : %H:%M:%S]',
      spellchecker_dialog: true,
      spellchecker_whitelist: ['Ephox', 'Moxiecode'],
      convert_urls: false
    };
    return _this;
  }

  _createClass(FoxEditorTinyMCE, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus;
      return _react.default.createElement(_tinymceReact.Editor, {
        value: value,
        apiKey: "no-api-key",
        init: this.initOptions,
        onBlur: onBlur,
        onFocus: onFocus,
        onPaste: function onPaste() {},
        onDrop: function onDrop() {},
        onSetContent: function onSetContent() {},
        onEditorChange: function onEditorChange(content) {
          var fakeE = {
            target: {
              value: content
            }
          };
          onChange(fakeE);
        }
      });
    }
  }]);

  return FoxEditorTinyMCE;
}(_react.PureComponent);

FoxEditorTinyMCE.propTypes = propTypes;
FoxEditorTinyMCE.defaultProps = defaultProps;
var _default = FoxEditorTinyMCE;
exports.default = _default;